/*
 * DataTableEmpty Messages
 *
 * This contains all the strings for the DataTableEmpty component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // No data title
  title: 'Oops!',
  // No data filter applied text
  filter: 'No result matching your request',
  // No data text
  result: 'No data found',
  // Reset button text
  resetButton: 'Reset',
});
